import useSalonPromoController from '@admin/api/useSalonPromoController'
import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import Resource from '@components/modules/Resource'
import React from 'react'
import PromocodeForm from './components/PromocodeForm'
import columns from './config/columns'

export default function SalonPromocodesPage() {
    const { salon } = useSalonManagerContext()
    const controller = useSalonPromoController(salon.state.id)

    return (
        <Resource
            cache={`admin:salon:${salon.state.id}:promos`}
            form={PromocodeForm}
            label="promo"
            controller={controller}
            columns={columns}
            heading="Promocodes" />
    )
}